import axios from "axios";

export const getPlan=()=>{
    return axios.get('/api/v1/payment/plan')
}

export const buyPlanApi=(plan_id)=>{
    return axios.post('/api/v1/payment/buy-plan',{plan_id})
}